import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { DoctoralCommittee, DoctoralCommitteeRequest } from './DoctoralCommitteeTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<DoctoralCommittee>>('/author/doctoral-committees/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<DoctoralCommittee>(`/author/doctoral-committees/${id}`).then(getData);
}

export function edit(id: Id, request: DoctoralCommitteeRequest) {
  return axios.put<DoctoralCommittee>(`/author/doctoral-committees/${id}`, request).then(getData);
}

export function create(request: DoctoralCommitteeRequest) {
  return axios.post<DoctoralCommittee>(`/author/doctoral-committees`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/doctoral-committees/${id}`).then(getData);
}
